import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=4c0c5132&scoped=true"
import script from "./SettingsNav.vue?vue&type=script&lang=js"
export * from "./SettingsNav.vue?vue&type=script&lang=js"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=4c0c5132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c5132",
  null
  
)

export default component.exports